import { render, staticRenderFns } from "./languageEdit.vue?vue&type=template&id=571925c0&scoped=true"
import script from "./languageEdit.vue?vue&type=script&lang=js"
export * from "./languageEdit.vue?vue&type=script&lang=js"
import style0 from "./languageEdit.vue?vue&type=style&index=0&id=571925c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571925c0",
  null
  
)

export default component.exports